<template>
  <div>
    <ActionBar
      class="pr-3 align-center"
      :disabled="loadingData"
      show-add
      @add="add"
      :disabled-add="updatingData"
      show-save
      @save="save()"
      :loading-save="updatingData"
    >
      <template v-slot:left>
        <div class="d-flex align-center">
          <v-card-title> Water line rules </v-card-title>
          <RevisionSelect
            label="Revision"
            style="width: 250px"
            class="float-right"
            density="compact"
            store-namespace="waterLineRuleRevision"
            :parameter="revisionKey"
          ></RevisionSelect>
        </div>
        <v-card-subtitle> Please configure the water line rules </v-card-subtitle>
      </template>
    </ActionBar>
    <v-lazy>
      <WaterLineRuleTable class="pa-3" ref="table" />
    </v-lazy>
    <RevisionDialog
      store-namespace="waterLineRuleRevision"
      :parameter="revisionKey"
      allow-no-revision="true"
    ></RevisionDialog>
  </div>
</template>

<script>
import WaterLineRuleTable from '@/components/waterlinerule/WaterLineRuleTable.vue'
import ActionBar from '@/components/common/ActionBar.vue'
import { mapState } from 'vuex'
import RevisionSelect from '@/components/revision/RevisionSelect.vue'
import { REVISION_KEY } from '@/components/constant'
import RevisionDialog from '@/components/revision/RevisionDialog.vue'

export default {
  name: 'WaterLineRuleView',
  components: { RevisionDialog, RevisionSelect, ActionBar, WaterLineRuleTable },
  computed: {
    ...mapState('waterLineRule', {
      loadingData: (state) => state.loadingData,
      updatingData: (state) => state.updatingData
    }),
    ...mapState('project', {
      currentProject: (state) => state.currentProject
    }),
    revisionKey() {
      return REVISION_KEY.WATER_LINE_RULE
    }
  },
  methods: {
    add() {
      this.$refs.table.add()
    },
    async save() {
      await this.$refs.table.saveChanges()
    }
  }
}
</script>

<style scoped></style>
